<template>
    <div class="form-group">
        <label>
            Ger Ita <button class="btn btn-sm btn-success ms-1" @click="add">+</button>
        </label>
        <div class="d-flex align-items-center" v-for="(item, i) in list" :key="i">
            <input type="text" v-model="item.ger" placeholder="GER" class="form-control me-1" />
            <input type="text" v-model="item.ita" placeholder="ITA" class="form-control mx-1" />
            <button class="btn btn-sm btn-danger ms-1" @click="removeIndex(i)">
                -
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class geritaList extends Vue {

    @Prop() list: OM.GerIta[];

    add(){
        let toPush = new OM.GerIta();
        this.list.push(toPush);
    }

    removeIndex(i){
        this.list.splice(i, 1);
    }

}

</script>

<style scoped>

    .accordion .accordionTitle {
        background: whitesmoke;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        align-items: center;
        cursor: pointer;
    }

    .accordion .accordionButton button {
        background: none;
        border: none;
        width: 33px;
        height: 33px;
    }

    .accordion .accordionBody {
    }

    .accordion .accordionBody.indent {
        padding-left: 20px;
    }

</style>
